import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: 'app-new-performance-detail-report-summary',
  templateUrl: './new-performance-detail-report-summary.component.html',
  styleUrls: ['./new-performance-detail-report-summary.component.less'],
})
export class NewPerformanceDetailReportSummaryComponent {
  @Input() columnName: any;
  @Input() perResults: any;
  @Input() queueRes: any;
  @Input() sortDirection: any;
  @Output() sortColumn = new EventEmitter<string>();
  selectedPercentile = 'ninetyPercentile';

  constructor() {}

  sortByColumn(columnName: string) {
    this.columnName = columnName;
    this.sortColumn.emit(columnName);
  }

  selectPercentile = [
    { label: '50%', value: 'fiftyPercentile' },
    { label: '80%', value: 'eightyPercentile' },
    { label: '90%', value: 'ninetyPercentile' },
    { label: '95%', value: 'ninetyFivePercentile' },
    { label: '99%', value: 'ninetyNinePercentile' }
  ];

  getSelectedLabel(): string {
    const selectedOption = this.selectPercentile.find(option => option.value === this.selectedPercentile);
    return selectedOption ? selectedOption.label : '';
  }

}
